<template>
    <div class="mesin-edc-card">
        <div v-for="(data, idx) in listMesinEdc" :key="`${idx}-${data.idmesin_edc}`" class="m-d-12 card-mesin">
            <SOSlotCard
                :id="`card-${data.idmesin_edc}`"
                :last-id="getLastId"
                :card-type="typeCard"
                @loadMore="doLoadMore"
                @toogleCard="toogleCard"
            >
                <template v-slot:before_head v-if="data.is_need_settlement || data.active === 0">
                    <div class="konfirmasi" v-if="data.is_need_settlement">
                        <label>
                            <span>
                                Menunggu konfirmasi settlement • {{ data.is_need_settlement_data.nominal | currency }}
                            </span>
                        </label>
                    </div>
                    <div class="non-active" v-if="data.active === 0">
                        <label class="m-d-0">
                            <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18Z"
                                    fill="#964040"
                                />
                                <path
                                    d="M10 7.16667V10.5"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10 13.8333H10.01"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <span>
                                Mesin dinonaktifkan
                            </span>
                        </label>
                    </div>
                </template>
                <template v-slot:card_head>
                    <div class="d-grid-12" @click="gotoDetail($event, data.idmesin_edc)">
                        <div class="grid-cspan-8">{{ data.nama_mesin_edc }}</div>
                        <div class="grid-cspan-4 a-center j-end">
                            <span class="f-12 f-c-midgrey f-regular b-box">{{ data.idakun_keuangan_mesin_edc }}</span
                            ><img src="@/assets/icons/chevron_right_4.svg" />
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div class="d-grid-12" @click="gotoDetail($event, data.idmesin_edc)">
                        <label class="grid-cspan-12 m-d-0">
                            <img
                                src="@/assets/icons/bank-account.svg"
                                alt=""
                                class="m-r-4"
                                style="height: 13px; margin-top: -2px"
                            />
                            {{ data.data_provider.nama }}
                        </label>
                        <label class="grid-cspan-12 m-d-0">
                            <img
                                src="../../../assets/icons/outlet-out-muted.svg"
                                alt=""
                                class="m-r-4"
                                style="height: 13px; margin-top: -2px"
                            />
                            {{ data.nama_outlet }}
                        </label>
                        <label class="grid-cspan-12 m-d-0 f-cont" v-if="data.rekening_owner">
                            Settlement ke {{ data.rekening_owner.nama }} - {{ data.rekening_owner.nomor_rekening }}
                        </label>
                        <label class="grid-cspan-12 m-d-0 f-cont" v-if="data.terakhir_settlement_raw">
                            {{ lastSettlement(data) }}
                        </label>
                    </div>
                </template>
                <template v-slot:card_footer>
                    <div class="d-grid-12 a-center">
                        <div class="grid-cspan-8 a-center">{{ data.saldo | currency }}</div>
                        <div class="grid-cspan-4 j-end f-12 f-regular" v-if="validateAccess('edc.settlement')">
                            <SOButton
                                :primary="data.is_need_settlement"
                                :outline="!data.is_need_settlement"
                                :full="true"
                                :disable="!isAllowSettlement(data)"
                                :text="`${data.is_need_settlement ? 'Konfirmasi' : 'Settlement'} >`"
                                :id="`btn-konfirm-settlement-${data.idmesin_edc}`"
                                @action="doAction($event, data)"
                                @hook:mounted="onMounted($event, data.idmesin_edc)"
                            />
                        </div>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
    name: "SOCardMesinEdc",
    props: {
        typeCard: {
            type: String,
            default: "shadow",
        },
        search: {
            type: Object,
        },
    },
    components: {
        SOSlotCard,
        SOButton,
    },
    computed: {
        ...mapGetters(moduleName, {
            pagination: "pagination",
            listMesinEdc: "listMesinEdc",
            endItemOfPage: "endItemOfPage",
            dataMesinEdc: "dataMesinEdc",
            isFetching: "isFetching",
        }),
        lastSettlement() {
            return (data) => {
                let last = data.terakhir_settlement;
                if (data.terakhir_settlement_raw) {
                    // Do something
                }
                return last;
            };
        },
        isAllowSettlement() {
            return (data) => {
                return data.saldo > 0 ? true : false;
            };
        },
        getLastId() {
            return this.endItemOfPage.idmesin_edc ? `card-${this.endItemOfPage.idmesin_edc}` : "";
        },
    },
    methods: {
        ...mapActions({
            setLoadMore: `${moduleName}/setLoadMore`,
            getListMesin: `${moduleName}/getListMesin`,
            toogleDisplayCard: `${moduleName}/toogleDisplayCard`,
        }),
        gotoDetail(e, mesinId) {
            this.$router.push({ name: "mesin.edc.detail", params: { id_mesin: mesinId } });
            this.smartTrackingClick("detail_mesin_edc");

        },
        onMounted(e, id) {
            let btn = document.getElementById(`btn-konfirm-settlement-${id}`);
            let textStyle = btn.childNodes[1].lastChild;

            textStyle.style.fontSize = "12px";
            btn.style.padding = "4px";
            btn.style.marginTop = "0px";
            btn.style.marginBottom = "0px";
        },
        doAction(e, { is_need_settlement, idmesin_edc, is_need_settlement_data }) {
            if (is_need_settlement) {
                let id = is_need_settlement_data ? is_need_settlement_data.id : "";
                this.$router.push({
                    name: "mesin.edc.detail.setoran",
                    params: { id_mesin: idmesin_edc, id_settlement: id },
                });
                this.smartTrackingClick("konfirmasi_settlement_mesin_edc");

            } else {
                this.$router.push({
                    name: "mesin.edc.pilih.pembayaran",
                    params: { id_mesin: idmesin_edc },
                });
                this.smartTrackingClick("add_settlement_mesin_edc");

            }
        },
        async doLoadMore() {
            if (this.dataMesinEdc.total > this.pagination.length) {
                if (!this.isFetching) {
                    await this.setLoadMore(true);
                    await this.getListMesin(this.search);
                }
            }
        },
        toogleCard(data) {
            this.toogleDisplayCard(data);
        },
    },
};
</script>
<style scoped>
.konfirmasi {
    margin-left: -18px;
    background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
    margin-right: -18px;
    margin-top: -10px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.konfirmasi label {
    padding: 0px 20px;
    color: #c29500;
}
.non-active {
    margin-left: -18px;
    background: linear-gradient(90deg, #fef0f0 0%, #ffffff 100%);
    margin-right: -18px;
    margin-top: -10px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.non-active label {
    padding: 0px 20px;
    color: #964040;
}
.a-center {
    align-self: center;
}
.j-end {
    justify-self: end;
}
.b-box {
    border: 1px solid #ededed;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0px 4px;
    padding-top: 1px;
}
</style>
